// @ts-nocheck
import { saveAs } from 'file-saver'

export const saveFile = (data: any, mimeType: string, fileName: string) => {
  const file = new Blob([data], { type: mimeType })
  saveAs(file, fileName)
}
